import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import ajaxFuelCategories from "../../util/remote/ajaxFuelCategories";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxFuelTanks from "../../util/remote/ajaxFuelTanks";

const RegisterFuelTankModal = (props) => {
  const [loading, setLoading] = useState(false);
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));

  const [stationID, setStationID] = useState(station_idd);
  const [fuel_category_id, setFuelCategoryID] = useState(null);
  const [tank_code, setTankCode] = useState("");
  const [capacity, setCapacity] = useState("");

  const allRowsFilled = () =>
    stationID && fuel_category_id && tank_code && capacity;

  // Submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }

    const data = {
      fuel_category_id: fuel_category_id,
      station_id: stationID,
      tank_code: tank_code,
      capacity: capacity,
    };

    setLoading(true);
    const response = await ajaxFuelTanks.create_fuel_Tanks(data);
    setLoading(false);

    if (response.status === "OK") {
      props.func(); // refresh parent
      toast.success(response.message || "Fuel Tank registered successfully");
      resetForm();
    } else {
      toast.error(response.message);
    }
  };

  const resetForm = () => {
    setStationID(null);
    setFuelCategoryID(null);
    setTankCode("");
    setCapacity("");
  };

  // Fetch stations
  const [stations_list, setStationsList] = useState([]);
  const fetchStations = async () => {
    setLoading(true);
    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: Number(d.id),
          label: d.station_name,
        }));
      setStationsList(list);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };

  // Fetch fuel categories
  const [fuel_categories_list, setFuelCategoriesList] = useState([]);
  const fetchFuelCategories = async () => {
    setLoading(true);
    const data = {
      station_id: 2,
    };
    const response = await ajaxFuelCategories.list_fuel_categories(data);
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: d.id,
          label: d.fuel_category,
        }));
      setFuelCategoriesList(list);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStations();
    fetchFuelCategories();
  }, []);

  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleAdd(e)}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? <Loader /> : "Register Fuel Tank"}
      </button>
    </>
  );

  return (
    <SystemModal title="Creating Fuel Tank" size="md" footer={RenderFooter}>
      <Toaster />
      {/* {loading && <Loader />} */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Register Fuel Tank</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* Station */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Select Station <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={stations_list}
                        isDisabled
                        value={stations_list.find((s) => s.value === stationID)}
                        onChange={(selected) => setStationID(selected.value)}
                        placeholder="Select station"
                      />
                    </div>

                    {/* Fuel Category */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Select Fuel Category
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={fuel_categories_list}
                        value={fuel_categories_list.find(
                          (c) => c.value === fuel_category_id
                        )}
                        onChange={(selected) =>
                          setFuelCategoryID(selected.value)
                        }
                        placeholder="Select fuel category"
                      />
                    </div>

                    {/* Tank Code */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Fuel Tank Code <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={tank_code}
                        onChange={(e) => setTankCode(e.target.value)}
                        className="form-control"
                        placeholder="Enter tank code, e.g diesel001#"
                        required
                      />
                    </div>

                    {/* Capacity */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Fuel Tank Capacity (liters)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="number"
                        value={capacity}
                        onChange={(e) => setCapacity(e.target.value)}
                        className="form-control"
                        placeholder="Enter capacity in liters"
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};

export default RegisterFuelTankModal;
